/**
 * @export
 * @class DealReport
 * MO 딜 신고하기 영역
 */
export default class DealReport {
  constructor() {
    this.welWrapper = $('.deal_report');
    this.setEvent();
  }

  setEvent() {
    this.welWrapper.on('click', 'a', this.handleClickReport);
  }

  handleClickReport(e) {
    e.preventDefault();

    const suggestUrl = TMON.htLocal.htURL.suggest;
    const dealSrl = TMON.htStaticData.htDealInfo.dealNo;
    const suggestUrlWithDealSrl = `${suggestUrl}?dealSrl=${dealSrl}`;

    if (TMON.sDevice === 'MW') {
      if (!TMON.bLogin) {
        TMON.oApp.oUtil.login(suggestUrlWithDealSrl);
        return;
      }
      window.open(suggestUrlWithDealSrl, '_blank');
    } else {
      const title = '신고하기';
      TMON.app.callApp(
        'webview',
        'showView',
        title,
        suggestUrlWithDealSrl,
        false,
        true
      );
    }
  }
}